{
  "header": {
    "login": "Iniciar sesión",
    "account": "Cuenta",
    "logout": "Cerrar sesión",
    "profile": "Perfil",
    "edit_profile": "Editar perfil",
    "quick_search": "Buscar...",
    "search_for": "Buscar Environet para",
    "current_org": "Organización actual",
    "collapse_menu": "Contraer menú",
    "sign_out": "Cerrar sesión",
    "support_ticket": "Boleto para solicitar soporte",
    "design_access_context": "Diseñar contexto de acceso",
    "select_org": "Seleccionar organización...",
    "select_role": "Seleccionar función...",
    "notifications": "Notificaciones",
    "unread_messages": "Tienes %{count} mensajes sin leer",
    "user_invitations": "Invitaciones de usuario",
    "access_context": "Contexto de acceso"
  }
}
